





















































































import { Vue, Component } from 'vue-property-decorator'
import { Loja } from '@/models'
import ListaDeLojas from '@/components/usuario/ListaDeLojas.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { gerar } from '@/api/spedFiscal'
import moment from 'moment'

@Component({
	components: { ListaDeLojas },
})
export default class TelaDeSpedFiscal extends Vue {
	lojas: Loja[] = []
	dataInicio = ''
	dataFim = ''
	menuInicio = false
	menuFim = false
	gerando = false

	created() {
		this.dataInicio = moment().startOf('month').format('YYYY-MM-DD')
		this.dataFim = moment().endOf('month').format('YYYY-MM-DD')
	}

	get dataInicioFormatada(): string {
		return this.dataInicio ? moment(this.dataInicio).format('DD/MM/YYYY') : ''
	}

	get dataFimFormatada(): string {
		return this.dataFim ? moment(this.dataFim).format('DD/MM/YYYY') : ''
	}

	get podeGerar(): boolean {
		return this.lojas.length > 0 && !!this.dataInicio && !!this.dataFim && this.dataInicio <= this.dataFim
	}

	async gerar() {
		if (!this.podeGerar) {
			AlertModule.setInfo('Selecione ao menos uma loja e um período válido.')
			return
		}
		try {
			this.gerando = true
			await gerar({
				lojaIds: this.lojas.map(l => l.id as string),
				dataInicio: this.dataInicio,
				dataFim: this.dataFim,
			})
			AlertModule.setSuccess('Geração iniciada! Acompanhe em Processos; você será avisado no sino ao concluir.')
			this.$router.push({ name: 'Processos' })
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.gerando = false
		}
	}
}
